<div class="persona-list" [ngClass]="{ 'grid': isGrid, 'stack': !isGrid }">
<nz-radio-group [(ngModel)]="value" (ngModelChange)="change($event)">
  <label [id]="'persona-' + persona.id" nz-radio *ngFor="let persona of (personaList$ | async)"
    [nzValue]="persona.id"
    [ngClass]="{ 'persona-filter': !isTypePersona(persona.type) }"
    (click)="onItemClick(persona.id)"
  >
    <ng-container *ngTemplateOutlet="personaTpl; context: { $implicit: persona }"></ng-container>
  </label>
</nz-radio-group>
</div>

<ng-template #personaTpl let-persona>
  <div class="persona">
    <div class="persona_icon-box" [class.long-text]="persona.longText">
      <img [attr.src]="persona.imgSrcOutline" [attr.alt]="persona.title" class="persona_icon">
    </div>
    <div class="persona_title" [class.long-text]="persona.longText">{{persona.title}}</div>
    <div class="start_text">Start <i class="fa-thin fa-arrow-right-long right-arrow-icon"></i></div>
  </div>
</ng-template>
